<div class="banner-stack" *ngIf="topBanner">
  <div class="banner" [ngClass]="cssClass(topBanner.type)" role="alert">
    <app-icon class="banner__icon" iconStyle="fas" iconType="fa" [iconName]="iconName(topBanner.type)"></app-icon>
    <span class="banner__message">{{ topBanner.message }}</span>
    <button
      type="button"
      class="banner__close"
      *ngIf="topBanner.isDismissible"
      aria-label="Dismiss"
      (click)="dismiss(topBanner)">
      <app-icon iconStyle="fas" iconType="fa" iconName="times"></app-icon>
    </button>
  </div>
</div>
